import DOMPurify from 'dompurify';

/**
 * Sanitização de texto rico (HTML) no cliente — deve espelhar o allowlist do
 * back (`content/domain/content-types/rich-text.ts`). Usada tanto ao ENVIAR
 * (defesa em profundidade) quanto ao RENDERIZAR HTML vindo da API.
 */
const ALLOWED_TAGS = [
  'p',
  'br',
  'span',
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'sub',
  'sup',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'h1',
  'h2',
  'h3',
  'a',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

/** True se, removidas as tags, não sobra texto visível (ex.: '<p></p>'). */
export function richTextIsEmpty(html: string): boolean {
  const text = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  return text.replace(/[\s ]+/g, '').length === 0;
}

/**
 * Sanitização do HTML de **preview de questão**. Difere de `sanitizeRichText`
 * num ponto só: `GET /admin/content/exams/:id/preview` troca cada
 * `{{img:<fileId>}}` por um `<img>` de verdade (só na resposta — o banco
 * guarda o token). Por isso `img` entra no allowlist aqui e não lá: aquele
 * roda também no caminho de escrita, onde o back não aceita `img`.
 */
export function sanitizeQuestionPreview(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...ALLOWED_TAGS, 'img'],
    ALLOWED_ATTR: [...ALLOWED_ATTR, 'src', 'alt'],
  });
}
